(function () {
  if (window.__expressCheckoutTrackingInit) return;
  window.__expressCheckoutTrackingInit = true;

  var WALLET_SELECTOR = [
    'shop-pay-wallet-button',
    'shopify-amazon-pay-button',
    'shopify-apple-pay-button',
    'shopify-google-pay-button',
    'shopify-paypal-button'
  ].join(', ');

  document.addEventListener('click', function (event) {
    var walletButton = event.target.closest(WALLET_SELECTOR);
    if (!walletButton) return;

    var container = walletButton.closest('.js-express-checkout-tracking');
    if (!container) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'express_checkout_click',
      product_id: container.dataset.productId,
      wallet_type: walletButton.tagName.toLowerCase()
    });
  });

  // Keep the express checkout button's quantity (hidden "quantity" field read by
  // {{ form | payment_button }}) in sync with the visible pack selector, which is
  // named "quantity_ui" and converts to real cart quantity as quantity_ui * multiplier.
  //
  // Shopify's accelerated checkout bundle re-syncs itself via a MutationObserver
  // scoped to attributeFilter: ["value"] on the form - it does NOT listen for
  // "change"/"input" events. Setting the DOM .value property alone never fires
  // that observer, so the actual "value" attribute must be set for the button to
  // pick up the new quantity.
  function syncExpressCheckoutQuantity(form) {
    if (!form) return;
    var quantityInput = form.querySelector('.js-express-checkout-quantity');
    var quantityUi = form.querySelector('[name="quantity_ui"]');
    if (!quantityInput || !quantityUi) return;

    var multiplierInput = form.querySelector('[name="multiplier"]');
    var packs = parseInt(quantityUi.value, 10) || 1;
    var multiplier = parseInt(multiplierInput && multiplierInput.value, 10) || 1;
    var total = String(packs * multiplier);

    if (quantityInput.getAttribute('value') !== total) {
      quantityInput.setAttribute('value', total);
      quantityInput.value = total;
    }
  }

  function syncAllExpressCheckoutForms() {
    document.querySelectorAll('.js-express-checkout-quantity').forEach(function (input) {
      syncExpressCheckoutQuantity(input.closest('form'));
    });
  }

  // Resync on any change/input inside a form that has an express checkout quantity
  // field - covers the quantity_ui stepper as well as variant swatches/selects
  // (name="option*"/"id"), which is what updates "multiplier" behind the scenes.
  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var form = event.target.closest && event.target.closest('form');
      if (!form || !form.querySelector('.js-express-checkout-quantity')) return;
      syncExpressCheckoutQuantity(form);
    });
  });

  // The theme's shared quantity stepper (quantity.js, bundled into
  // layout.theme.js) rewrites the quantity_ui number input into a
  // ".js-qty" widget with ".js-qty__adjust" +/- buttons. Its click handler
  // updates the input via jQuery's $.val(), which never fires a "change"/
  // "input" event and never touches the "value" attribute - so the two
  // listeners above can't see it. Its handler is bound directly on the
  // button (not delegated), so it already ran and updated the value by the
  // time this bubbles up to document.
  document.addEventListener('click', function (event) {
    var adjustButton = event.target.closest && event.target.closest('.js-qty__adjust');
    if (!adjustButton) return;
    var form = adjustButton.closest('form');
    if (!form || !form.querySelector('.js-express-checkout-quantity')) return;
    syncExpressCheckoutQuantity(form);
  });

  syncAllExpressCheckoutForms();
})();
